var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex column pt100 pb100 flex-center"},[(_vm.showPic)?_c('img',{attrs:{"src":_vm.src,"width":_vm.width,"alt":""}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"color_999 tac",domProps:{"innerHTML":_vm._s(_vm.text)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-da9560aa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/plugins/no-data.vue
// module id = 296
// module chunks = 379 380